import CryptoJS from "crypto-js";
 
// ✅ SAME key and IV as .NET backend

const secretKey = CryptoJS.enc.Utf8.parse("2Xy@#%ZL9mMdk348ABcdEfghIJklmnop"); // 32 chars

const iv = CryptoJS.enc.Utf8.parse("bcdEfghIJklmnop1"); // 16 chars
 
// 🔐 Encrypt any JS object (array or object)

export function encryptData(data) {

  const jsonString = JSON.stringify(data);
 
  const encrypted = CryptoJS.AES.encrypt(jsonString, secretKey, {

    iv: iv,

    mode: CryptoJS.mode.CBC,

    padding: CryptoJS.pad.Pkcs7,

  });
 
  return encrypted.toString(); // base64

}
 
// 🔓 Decrypt to original object

export function decryptData(base64String) {

  const decrypted = CryptoJS.AES.decrypt(base64String, secretKey, {

    iv: iv,

    mode: CryptoJS.mode.CBC,

    padding: CryptoJS.pad.Pkcs7,

  });
 
  const plainText = decrypted.toString(CryptoJS.enc.Utf8);

  return JSON.parse(plainText);

}

 